module.exports = __webpack_public_path__ + "img/1580388774.d46c8ea8.jpg";